var _path, _path2, _path3, _path4, _path5, _rect, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKetchLogoWithText = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 44,
    viewBox: "0 0 128 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.7292 11.7439V31.5728H60.346V24.0944L62.3646 22.0266L68.7009 31.5728H73.355L65.1683 19.3355L72.6822 11.7439H68.0561L60.346 19.6471V11.7439H56.7292Z",
    fill: "#071A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0466 22.3382C76.411 20.582 77.7568 19.4772 79.8035 19.4772C81.8502 19.4772 83.252 20.4686 83.5604 22.3382H76.0466ZM80.0558 31.8561C82.4109 31.8561 84.794 31.1479 86.336 29.4766L83.8408 27.2105C82.9997 28.0886 81.7661 28.5985 80.2521 28.5985C77.7568 28.5985 76.1867 27.2388 75.9624 25.3975H87.2332C87.2893 24.8593 87.3173 24.2928 87.3173 23.8679C87.3173 18.9107 84.1772 16.2196 79.8596 16.2196C75.5419 16.2196 72.1775 19.5622 72.1775 24.1511C72.1775 28.7401 75.4578 31.8561 80.0558 31.8561Z",
    fill: "#071A24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1117 11.7439V25.4541C89.1117 29.4199 91.2425 31.5728 95.1676 31.5728H97.9993V28.1169H95.448C93.7378 28.1169 92.7565 27.1254 92.7565 25.3975V20.0154H97.9993V16.5028H92.7565V11.7439H89.1117Z",
    fill: "#071A24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.326 28.2586C103.999 28.2586 102.485 26.5873 102.485 24.0378C102.485 21.4884 103.999 19.8171 106.326 19.8171C107.924 19.8171 109.158 20.6386 109.747 22.055L113.223 20.3553C112.102 17.8342 109.578 16.2196 106.438 16.2196C102.009 16.2196 98.6161 19.5055 98.6161 24.1795C98.6161 28.8534 101.812 31.8561 106.242 31.8561C109.382 31.8561 111.962 30.2131 113.139 27.692L109.803 26.0491C109.102 27.3804 107.84 28.2586 106.326 28.2586Z",
    fill: "#071A24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.326 23.188V31.5728H127.971V22.5365C127.971 18.7123 125.812 16.2196 122.195 16.2196C120.709 16.2196 119.391 16.6445 118.354 17.381V11.7439H114.765V31.5728H118.354V23.188C118.354 21.0351 119.532 19.8171 121.55 19.8171C123.316 19.8171 124.326 21.0351 124.326 23.188Z",
    fill: "#071A24"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43.524,
    height: 44,
    fill: "#8D4DFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2315 11.7931L29.9496 7H18.3905L5.93506 19.6533L18.2924 32.2069L13.5743 37H25.1334L37.5888 24.3467L25.2315 11.7931ZM18.3905 32.1064V18.7437L25.1334 11.8936V25.2563L18.3905 32.1073V32.1064Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKetchLogoWithText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ketch_logo_with_text.055f1a3ddcc4f35efbe25501795481f0.svg";